import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { BaseCartProduct } from '~shared-components/model/cart.model'

export interface CartModalState {
  isOpen: boolean
  product: BaseCartProduct | undefined
  type: 'cart' | 'quote'
}

export type OpenCartModalPayload = Omit<CartModalState, 'isOpen'>

export const initialCartModalState: CartModalState = {
  isOpen: false,
  product: undefined,
  type: 'cart',
}

export const cartModalSlice = createSlice({
  initialState: initialCartModalState,
  name: 'cartModal',
  reducers: {
    closeCartModal() {
      return initialCartModalState
    },
    openCartModal(
      state,
      { payload: { product, type } }: PayloadAction<OpenCartModalPayload>,
    ) {
      state.isOpen = true
      state.product = product
      state.type = type
    },
  },
})

export default cartModalSlice.reducer
